import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environments';

// console.log(`✅ Environnement actif : ${environment.envName}`);
// console.log(`🌍 URL du backend : ${environment.apiBaseUrl}`);
if (environment.production) {
  console.log = () => {};
  console.debug = () => {};
}
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
